import { useState } from 'react';

import { isMobile } from 'hooks';
import { Dialog, InfoBlock } from 'components';

import * as Styles from './styles';
import { TemplateDialogProps } from './types';

export const TemplateDialog = ({
  icon,
  title,
  onOpen,
  children,
  triggerRef,
  triggerTitle,
  ...props
}: TemplateDialogProps) => {
  const mobile = isMobile();
  const [open, setOpen] = useState(false);

  return (
    <>
      <InfoBlock
        ref={triggerRef}
        onClick={() => {
          setOpen(true);
          onOpen?.();
        }}
      >
        <Styles.CardContainer>
          {icon}
          <h3>{triggerTitle || title}</h3>
        </Styles.CardContainer>
      </InfoBlock>

      <Dialog
        open={open}
        title={title}
        removeAutofocus
        closeOnDocumentClick={false}
        onClose={() => setOpen(false)}
        width={mobile ? '90vw' : '520px'}
        {...props}
      >
        {children}
      </Dialog>
    </>
  );
};
